import { Action } from 'redux';
import { action } from 'typesafe-actions';

import { Category } from 'helpers/models';

import { FilterTypes } from './types';

export const setCategoryFilter = (selectedCategory: Category): Action => (
  action(FilterTypes.SET_CATEGORY_FILTER, { selectedCategory })
);